module.exports = __webpack_public_path__ + "media/images/active_material/icons/event-05848e75fb80c02be3f52a02b66baacb.svg";